import { render, staticRenderFns } from "./ActivityTabInterventions.vue?vue&type=template&id=d0faf04e&"
import script from "./ActivityTabInterventions.vue?vue&type=script&lang=js&"
export * from "./ActivityTabInterventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports